import React, { useState, useEffect } from 'react';

const IPTVChannelForm = ({ initialData, categories, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    stream_url: '',
    logo_url: '',
    category: 'General',
    epg_id: '',
    sort_order: 0,
    is_active: true
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        description: initialData.description || '',
        stream_url: initialData.stream_url || '',
        logo_url: initialData.logo_url || '',
        category: initialData.category || 'General',
        epg_id: initialData.epg_id || '',
        sort_order: initialData.sort_order || 0,
        is_active: initialData.is_active !== false
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  // Get unique categories
  const uniqueCategories = [...new Set(categories.map(c => c.category))];

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Channel Name *</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Enter channel name"
          />
        </div>
        
        <div className="col-md-6 mb-3">
          <label className="form-label">Category</label>
          <select
            className="form-select"
            name="category"
            value={formData.category}
            onChange={handleChange}
          >
            <option value="General">General</option>
            {uniqueCategories.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Stream URL *</label>
        <input
          type="url"
          className="form-control"
          name="stream_url"
          value={formData.stream_url}
          onChange={handleChange}
          required
          placeholder="https://example.com/stream.m3u8"
        />
        <small className="text-muted">HLS or direct stream URL</small>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Logo URL</label>
          <input
            type="url"
            className="form-control"
            name="logo_url"
            value={formData.logo_url}
            onChange={handleChange}
            placeholder="https://example.com/logo.png"
          />
        </div>
        
        <div className="col-md-6 mb-3">
          <label className="form-label">EPG ID</label>
          <input
            type="text"
            className="form-control"
            name="epg_id"
            value={formData.epg_id}
            onChange={handleChange}
            placeholder="channel.epg.id"
          />
          <small className="text-muted">Electronic Program Guide identifier</small>
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Description</label>
        <textarea
          className="form-control"
          name="description"
          value={formData.description}
          onChange={handleChange}
          rows="2"
          placeholder="Channel description"
        />
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Sort Order</label>
          <input
            type="number"
            className="form-control"
            name="sort_order"
            value={formData.sort_order}
            onChange={handleChange}
            min="0"
          />
        </div>
        
        <div className="col-md-6 mb-3">
          <div className="form-check mt-4">
            <input
              className="form-check-input"
              type="checkbox"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
              id="is_active"
            />
            <label className="form-check-label" htmlFor="is_active">
              Active
            </label>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-2">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          {initialData ? 'Update Channel' : 'Create Channel'}
        </button>
      </div>
    </form>
  );
};

export default IPTVChannelForm;
